<div class="productImage__actionLinks">
  <vc-like
    class="productImage__link"
    type="products"
    className="productPage__like"
    [isOldDesign]="true"
    [isLiked]="isLiked"
    [idItem]="product.id"
    [likeCount]="product.likeCount"
    (likeSuccess)="likeSuccess($event)"
  ></vc-like>

  <button class="productImage__link productImage__link--discussion" (click)="this.scrollTo.emit('block_comments')">
    <vc-sprite-icons class="svg svg__bubble" name="talk"></vc-sprite-icons>
    <span class="d-none d-md-inline productImage__link--text" i18n="@@PRODUCT.IMAGE_ACTIONS.GOTO_DISCUSSIONS"
      >Add a comment</span
    >
  </button>

  <button
    class="productImage__link productImage__link--share tooltipContainer tooltipContainer--jsToggle"
    [class.tooltipContainer--active]="shareTooltipIsOpen"
    (click)="toggleShareTooltip()"
    (focusout)="closeShareTooltip()"
  >
    <vc-sprite-icons class="svg svg__shareArrow" name="arrow-share-line"></vc-sprite-icons>
    <span class="d-none d-md-inline productImage__link--text" i18n="@@PRODUCT.IMAGE_ACTIONS.SHARE"
      >Share this item</span
    >

    <vc-product-share
      class="productImage__tooltip tooltip tooltip--top--right tooltip-md--top"
      [product]="product"
    ></vc-product-share>
  </button>
</div>
